<template>
  <div class="rearMain noSelect" id="img_canvas_rearMain" @click="off()">
    <div class="top_til noSelect">
      <div class="top_logo">
        <div class="logoImg" :style="{background:`url('./image/icon_logo.png')`,backgroundSize:'100% 100%'}"></div>
      </div>
      <div class="top_model">
        <div :class="{active_div:$store.state.modelType===0}" @click="getModel(0)">数据处理</div>
        <div :class="{active_div:$store.state.modelType===1}" @click="getModel(1)">综合展现</div>
        <div :class="{active_div:$store.state.modelType===5}" @click="getModel(5)">中心管控</div>
        <div :class="{active_div:$store.state.modelType===7}" @click="getModel(7)">模型生成</div>
        <!-- <div :class="{active_div:$store.state.modelType===8}" @click="getModel(8)">自定义报表</div> -->
        <!-- <div :class="{active_div:$store.state.modelType===2}" @click="getModel(2)">中心管控</div> -->
        <!-- <div :class="{active_div:$store.state.modelType===3}" @click="getModel(3)">运维管理</div> -->
      </div>
      <div class="help">
        <el-tooltip class="item" effect="dark" content="帮助" placement="top">
          <img src="../../../public/image/help1.png" @click="getDialog(0)">
        </el-tooltip>
      </div>
      <div class="top_journal">
        <el-tooltip class="item" effect="dark" content="日志" placement="top">
          <img src="../../../public/image/rizhi1.png" @click="getJournal(0)">
        </el-tooltip>
      </div>
      <div class="top_all">
        <el-tooltip class="item" effect="dark" content="全屏" placement="top">
          <img src="../../../public/image/on.png" @click="handleFullscreen" v-if="!fullScreen">
          <img src="../../../public/image/off.png" @click="handleFullscreen" v-else>
        </el-tooltip>
      </div>
      <div class="top_header">
        <el-tooltip class="item" effect="dark" content="个人信息" placement="top">
          <img src="../../assets/common/image/headlogo.png" @click.stop="isPop()">
        </el-tooltip>
        <div class="userInfoCard" id="box" style="display:none">
          <div class="img-warp">
            <img src="../../assets/common/image/headlogo.png">
            <span class="username">{{userData.userName}}</span>
          </div>
          <div class="id">
            手机号：{{userData.phone}}
          </div>
          <div class="member-rank" @click="contact(0)">
            <div class="free">
              <img src="../../assets/common/image/vip1.png">
              {{userState}}
            </div>
            <div class="forever">
              <img src="../../assets/common/image/time.png">
              {{expirationTime}}
            </div>
            <div class="up">升级</div>
          </div>
          <div class="invitation" @click="upgrade()">
            <img src="../../assets/common/image/invitation.png">
            <span>联系我们</span>
          </div>
          <div class="invitation" @click="Invite(0)">
            <img src="../../assets/common/image/invitation.png">
            <span>邀请注册</span>
          </div>
          <div class="invitation" @click="onloadHelp()">
            <img src="../../assets/common/image/help.png">
            <span>帮助手册下载</span>
          </div>
          <div class="invitation" @click="getClose">
            <img src="../../assets/common/image/goout.png">
            <span>退出登录</span>
          </div>
        </div>
      </div>
    </div>
    <div class="count" :class="{'screenCount':$route.name==='configScreen'}" v-if="$store.state.modelType!==0">
      <div class="breadcrumb noSelect">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="item in $store.state.subTileList">
            <span v-if="!item.path">{{item.name}}</span>
            <span @click="getRouterPath(item.path)" class="path_item" v-else>{{item.name}}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="btn_url">
          <div v-if="$store.state.modelType===3">
            <FUrlBtn title="查找用户" :IconSize="16" path="/findUser"></FUrlBtn>
            <FUrlBtn title="用户列表管理" :IconSize="14" path="/userList"></FUrlBtn>
          </div>
        </div>
      </div>
    </div>
    <div class="count_view">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" ref="mainChild"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" ref="mainChild"></router-view>
    </div>

    <FNews v-if="preview" :newslist="newslist"></FNews>
    <div v-if="this.journalShow" class="journal_dialog">
      <div class="left" @click="getJournal(1)"></div>
      <div class="right">
        <div class="search">
          按关键字：
          <el-input placeholder="请输入关键字" clearable icon="search" size="small" v-model="search"></el-input>
          按时间：
          <el-date-picker size="small" v-model="value1" type="datetime" placeholder="选择日期时间" align="right" format="yyyy-MM-dd" :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="journal_table">
          <el-table :data="tables" style="width: 100%" height="100%">
            <el-table-column sortable prop="handleTime" label="操作时间">
            </el-table-column>
            <el-table-column sortable prop="handleUserName" label="操作人">
            </el-table-column>
            <el-table-column prop="handleItem" label="操作项">
            </el-table-column>
            <el-table-column prop="handleContent" label="操作内容">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <FDialog class="Invite" :dialog="viewSetDialog.show" title="" @close="Invite(1)" moveWidth="400px">
      <div class="info">
        <div class="title">邀请新用户</div>
        <div class="person" id="screenName">邀请人：{{userData.userName}}</div>
        <div class="num" id="screenPerson">邀请码：{{number}}</div>
        <div class="link" id="screenLink">注册链接：</div>
        <div class="link"><a :href="before+'#/login'" target="_blank">{{before}}#/login</a></div>
        <div class="button">
          <el-button type="info" size="small" @click="copyAll()">复制全部信息</el-button>
          <el-button type="primary" size="small" @click="copyLink()">复制该链接</el-button>
        </div>
      </div>
    </FDialog>
    <FDialog class="details_dialog" :dialog="add.dialog" :title="add.title" moveWidth="610px" @close="getDialog(1)">
      <div class="help1" v-if="this.url ==1 ">
        <img src="../../../public/image/help/1.jpg">
        添加—选择数据接入类型—输入数据接入信息—点击连接
      </div>

      <div class="help1" v-if="this.url ==2 ">
        <img src="../../../public/image/help/2.jpg">
        选择左侧的数据准备-选择上方的数据处理方法
      </div>

      <div class="help1" v-if="this.url ==3 ">
        <img src="../../../public/image/help/3.jpg">
        给多维分析组新建图表
        <img src="../../../public/image/help/4.jpg">
        通过拖拽完善维度和度量字段—选择右侧的图表样式—点击保存
      </div>
      <div class="help1" v-if="this.url ==4 ">
        <img src="../../../public/image/help/5.jpg">
        选择分辨率或者模板—选择模板尺寸—选择模板样式—点击新增大屏
        <img src="../../../public/image/help/6.jpg">
        点击编辑图标或者下方加号图标新建大屏后进行大屏配置
      </div>
      <div class="help1" v-if="this.url ==5 ">
        <img src="../../../public/image/help/7.jpg">
        <img src="../../../public/image/help/8.jpg">
        选择分享人—选择多维分析图表—选择大屏—点击保存—点击确定
      </div>
    </FDialog>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Footer from '@/components/Footer/Footer.vue'

//多维分析
import config from "@/assets/js/config";
import { delAllData, getToken, getUser } from '@/assets/js/basis'

import { CreateInvitationCode } from '@/assets/axios/invite/invite'

import {
  //获取消息内容
  getTeamSharingNewsList,
} from '@/assets/axios/rearMain'
import {
  //获取消息内容
  GetSharedLog,
} from '@/assets/axios/share/share'
import router from '@/router'
import {
  closeMQ
} from '@/components/Sock/RabbitMQ'
export default {
  name: 'rearMain',
  components: {
    Footer,
  },
  props: [],
  data() {
    return {
      lastTime: null, // 鼠标最后一次点击时间
      currentTime: null, // 当前时间
      sys_timeout: 10 * 60 * 1000, // 系统安全时间
      check_time: 30 * 1000, //探测间隔时间
      timer: null,  // 定时器
      userID: "",
      url: "",
      add: {
        dialog: false,
        title: '帮助',
        type: 0,
      },
      number: "",
      viewSetDialog: {
        id: '',
        show: false,
        type: 1,
        typeList: [],
      },
      expirationTime: "",
      userData: {},
      userState: "",
      popShow: false,
      tableData: [{
        handleTime: '2022-04-04',
        handleUserName: '韩海栋',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-03',
        handleUserName: '虞林学',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-02',
        handleUserName: '虞发建',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-04',
        handleUserName: '廉　松',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-01',
        handleUserName: '蒋楠学',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '柯浩航',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '龚先壮',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '汤　昌',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '金功平',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '金岩仁',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '文　梁',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '廉敬达',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '强伟梁',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '岳　建',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '区启雄',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '柯良峰',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '李若贵',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '邹坚炎',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '田文辉',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '席群东',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '邓勇致',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '武轮思',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '王小虎',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '古良翰',
        handleItem: '广州',
        handleContent: '广州市白云区白云路8号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '凌辉有',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '方政岩',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '莫　海',
        handleItem: '大同',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '贺　若',
        handleItem: '运城',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '田健致',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '陆邦承',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '蔡之仁',
        handleItem: '石河子',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '王震家',
        handleItem: '乌鲁木齐',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '武轮思',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-13',
        handleUserName: '施力晨',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }, {
        handleTime: '2022-04-06',
        handleUserName: '孔固乐',
        handleItem: '上海',
        handleContent: '上海市普陀区金沙江路 1518 弄',
      }, {
        handleTime: '2022-04-07',
        handleUserName: '温豪元',
        handleItem: '北京',
        handleContent: '北京市昌平区珠江摩尔大厦5号楼',
      }],
      search: '',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      value1: '',
      journalShow: false,
      //模块分类
      model_type: 0,
      value: '',
      //未读消息数量
      NoNewsNumber: 0,
      newslist: [],
      //预览弹框
      preview: false,
      //全屏
      fullScreen: false,
    }
  },
  computed: {
    tables: function () {
      var search = this.search;
      var str = this.value1 + "";
      var str = str.substring(0, 24);// Or str = str.substring(0, 24)
      var d = new Date(str);
      var a = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
      for (var i = 0, len = a.length; i < len; i++) {
        if (a[i] < 10) {
          a[i] = '0' + a[i];
        }
      }
      str = a[0] + '-' + a[1] + '-' + a[2];
      // alert(str);
      var day = str;
      if (search && !this.value1) {
        return this.tableData.filter(function (dataNews) {
          return Object.keys(dataNews).some(function (key) {
            return String(dataNews[key]).toLowerCase().indexOf(search) > -1
          })
        })
      }
      else if (!search && this.value1) {
        return this.tableData.filter(function (dataNews) {
          return Object.keys(dataNews).some(function (key) {
            return String(dataNews[key]).toLowerCase().indexOf(day) > -1
          })
        })
      } else if (search && this.value1) {
        return this.tableData.filter(function (dataNews) {
          return Object.keys(dataNews).some(function (key) {
            return String(dataNews[key]).toLowerCase().indexOf(search && day) > -1
          })
        })
      }
      return this.tableData
    }
  },
  methods: {
    //获取参数
    init() {
    },
    onload() {
      this.timer = window.setInterval(this.checkTimeOut, this.check_time)
    },
    // 判断系统无操作时间是否大于安全时间
    checkTimeOut() {
      this.currentTime = new Date().getTime();
      if (this.currentTime - this.lastTime > this.sys_timeout) {
        // todo 退出登录
        closeMQ();
        this.$router.push('/login')
      }
    },
    onloadHelp() {
      window.open('http://175.27.191.97:8060/File/智呈可视化工具说明书.docx')
    },
    getDialog(type) {
      var url = window.location.href
      if (url.indexOf('dataSource') != -1) {
        this.url = 1;
      } else if (url.indexOf('dataSet') != -1) {
        this.url = 2;
      } else if (url.indexOf('viewSet') != -1) {
        this.url = 3;
      } else if (url.indexOf('addStencil') != -1 || url.indexOf('stencilList') != -1 || url.indexOf('viewScreen') != -1 || url.indexOf('configScreen') != -1) {
        this.url = 4;
      } else if (url.indexOf('share') != -1) {
        this.url = 5;
      }
      if (type === 0) {
        this.add.dialog = true;
      }
      else if (type === 1) {
        this.add.dialog = false;
      }

    },
    Invite(type) {
      if (type === 0) {
        CreateInvitationCode().then(res => {
          if (res.code === 200) {
            this.number = res.data
          }
        })
        this.viewSetDialog.show = true;

      } else if (type === 1) {
        this.viewSetDialog.show = false;
      }
    },
    copyLink() {
      var text = `${this.before}#/login`
      var copy = function (e) {
        e.preventDefault();
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', text);
        } else if (window.clipboardData) {
          window.clipboardData.setData('Text', text);
        }
      }
      this.getMsg('复制成功', 'success');
      window.addEventListener('copy', copy);
      document.execCommand('copy');
      window.removeEventListener('copy', copy);
    },
    copyAll() {
      var screenTopicHtml = "智呈可视化工具平注册"
      var screenName = document.getElementById("screenName")
      var screenNameHtml = screenName.innerHTML
      var screenPerson = document.getElementById("screenPerson")
      var screenPersonHtml = screenPerson.innerHTML
      var screenLink = document.getElementById("screenLink")
      var screenLinkHtml = screenLink.innerHTML
      var text = `${screenTopicHtml}\n${screenNameHtml}\n${screenPersonHtml}\n${screenLinkHtml}${this.before}#/login`
      var copy = function (e) {
        e.preventDefault();
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', text);
        } else if (window.clipboardData) {
          window.clipboardData.setData('Text', text);
        }
      }
      this.getMsg('复制成功', 'success');
      window.addEventListener('copy', copy);
      document.execCommand('copy');
      window.removeEventListener('copy', copy);
    },
    off() {
      this.popShow = true;
      if (this.popShow == true) {
        var box = document.getElementById("box");
        box.style.display = "none"
        this.popShow = false;
      }
    },
    isPop() {
      this.userData = localStorage.getItem('user_data')
      this.userData = JSON.parse(this.userData)
      var box = document.getElementById("box");
      if (this.popShow) {
        box.style.display = "none"
        this.popShow = !this.popShow;
      } else {
        box.style.display = "block"
        this.popShow = !this.popShow;
      }
      var forever = document.getElementsByClassName("forever");

      if (this.userData.customerType == 1) {
        this.userState = "试用用户"
      } else if (this.userData.customerType == 2) {
        this.userState = "普通用户"
      } else if (this.userData.customerType == 3) {
        this.userState = "永久用户"
        forever.style.display = 'none'
      }

      this.expirationTime = this.userData.expirationTime.slice(0, 10)
    },
    upgrade() {
      const route = router.resolve({ path: `/contact` });
      window.open(route.href, '_blank')
    },
    contact() {
      const route = router.resolve({ path: `/upVip` });
      window.open(route.href, '_blank')
    },
    getJournal(type) {
      var body = document.querySelector("body")
      if (type === 0) {
        this.journalShow = true;
        body.style.overflow = "hidden"
        GetSharedLog().then(res => {
          this.tableData = res.data
        })
      } else if (type === 1) {
        this.journalShow = false;
        body.style.overflow = "auto"
      }
    },
    //切换模块
    getModel(id) {
      let vux = this.$store.state;
      this.getRouterPath(vux.modelRoute[id]);
      if (vux.modelType === id) {
        return;
      }
      vux.modelType = id;
      let routePath = config.routePath;
      let count = 0;
      for (let i in routePath) {
        if (count === id) {
          this.getRouterPath(routePath[i][0].path);
        }
        count++;
      }
    },
    //退出
    getClose() {
      this.$alert('您确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
      }).then(() => {
        delAllData();
        closeMQ();
        this.$router.push('/login')
      }).catch(() => {

      });
    },
    //获取消息
    getNoNewsNumber() {
      getTeamSharingNewsList().then(res => {
        if (res.code === 200) {
          this.newslist = res.data.dataTabel.sharingList || [];
          this.NoNewsNumber = res.data.dataTabel.unreadCount;
          this.preview = true;
        }
      })
    },
    //全屏
    handleFullscreen() {
      let main = document.body
      if (this.fullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.fullScreen = false;
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen()
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen()
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen()
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen()
        }
        this.fullScreen = true;
      }
    },
  },
  watch: {
    search() {
      if (this.search) {
        this.value1 = "";
      }
    },
    value1() {
      if (this.value1) {
        this.search = "";
      }
    },
  },
  created() {
    this.before = window.location.href.split('#')[0]
  },
  mounted() {
    this.init();
    this.currentTime = new Date().getTime();
    this.lastTime = new Date().getTime();
    // 监听鼠标点击时间，获取最后一次点击时间
    window.document.onmousedown = (event) => {
      this.lastTime = new Date().getTime();
    }
    this.onload();
    let today = new Date();
    let licTime = new Date("2099-08-01 00:00:00");
    if (today > licTime) {
      alert("您的授权已到期，请联系管理员！");
      closeMQ();
      this.$router.push('/login')
    }
    
    this.getNoNewsNumber();
    this.getSubTil(this);
    this.$router.beforeEach((to, from, next) => {
      this.cacheRoute(this, to);
      next();
    });
    this.$router.afterEach((to, from) => {
      this.getSubTil(this);
    });
  },
  updated() {
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="less">
.rearMain {
  width: 100%;
  height: 100%;
  position: relative;

  .top_til {
    width: 100%;
    height: 120px;
    background-color: @h_top_backColor;
    white-space: nowrap;
    position: relative;
    text-align: center;

    .top_logo {
      position: absolute;
      left: 53px;
      height: 100%;

      .logoImg {
        background-size: 100% 100%;
        width: 96px;
        height: 72px;
        .com_middle;
        float: left;
        margin-right: 10px;
      }
    }
    .top_title {
      display: block;
      position: absolute;
      left: 42%;
      height: 100%;
      @font-face {
        font-family: "华康新综艺";
        src: url("../../../theme/fonts/huakangxinzongyi.ttf");
      }
      > span {
        display: inline-block;
        height: 100%;
        float: left;
        line-height: 120px;
        letter-spacing: 2px;
        font-size: 36px;
        font-family: "华康新综艺";
      }
    }

    .top_model {
      position: absolute;
      display: inline-block;
      height: 100%;
      left: 13%;
      width: 60%;
      > div {
        color: @h_top_fontColor;
        height: 100%;
        display: inline-block;
        float: left;
        line-height: 120px;
        padding: 0 1%;
        cursor: pointer;
        letter-spacing: 1px;
        margin: 0 5px;
        font-size: 22px;
      }

      > .active_div {
        position: relative;
        color: #0c0c54;
      }
      > .active_div::after {
        position: absolute;
        bottom: 40px;
        left: 10px;
        right: 10px;
        height: 5px;
        content: "";
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        background-color: #0c0c54;
      }
    }
    .top_header {
      position: absolute;
      right: 25px;
      display: inline-block;
      height: 100%;
      float: right;
      line-height: 150px;
      img {
        width: 50px;
        height: 50px;
      }
      .userInfoCard {
        width: 240px;
        height: 472px;
        box-shadow: 0 0 20px 0 rgb(0 0 0 / 5%);
        border-radius: 8px;
        background: #fff;
        position: absolute;
        right: 0;
        top: 100px;
        z-index: 999;
        padding: 24px 24px 10px;
        .img-warp {
          height: 38px;
          cursor: pointer;
          margin-left: 10px;
          img {
            width: 38px;
            height: 38px;
            -o-object-fit: cover;
            object-fit: cover;
            margin-right: 15px;
            border-radius: 50%;
            border: 2px solid transparent;
            vertical-align: middle;
            image-rendering: -webkit-optimize-contrast;
            float: left;
          }
          .username {
            float: left;
            height: 38px;
            line-height: 38px;
            display: inline-block;
            font-size: 14px;
            vertical-align: middle;
          }
        }
        .id {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #999;
          text-align: left;
          margin: 12px 0 12px 12px;
        }
        .member-rank {
          display: flex;
          align-items: center;
          -webkit-box-pack: justify;
          justify-content: space-between;
          position: relative;
          height: 36px;
          line-height: 36px;
          margin-bottom: 10px;
          padding: 0 10px;
          border-radius: 5px;
          background-color: #f6f6f9;
          cursor: pointer;
          .free {
            font-size: 13px;
            font-weight: 600;
            color: #000;
            img {
              width: 26px;
              height: 26px;
              -o-object-fit: cover;
              object-fit: cover;
              margin-right: 5px;
              border-radius: 50%;
              border: 2px solid transparent;
              vertical-align: middle;
              image-rendering: -webkit-optimize-contrast;
              float: left;
              margin-top: 5px;
            }
          }
          .forever {
            font-size: 12px;
            color: #949496;
            img {
              width: 20px;
              height: 20px;
              -o-object-fit: cover;
              object-fit: cover;
              border-radius: 50%;
              border: 2px solid transparent;
              vertical-align: middle;
              image-rendering: -webkit-optimize-contrast;
              float: left;
              margin-top: 8px;
            }
          }

          .up {
            font-size: 12px;
            color: #0068dd;
            display: none;
          }
        }
        .invitation {
          position: relative;
          height: 36px;
          line-height: 36px;
          margin-bottom: 10px;
          padding: 0 10px;
          border-radius: 5px;
          background-color: #fff;
          cursor: pointer;
          font-size: 12px;
          img {
            width: 20px;
            height: 20px;
            -o-object-fit: cover;
            object-fit: cover;
            margin-right: 10px;
            border-radius: 50%;
            border: 2px solid transparent;
            vertical-align: middle;
            image-rendering: -webkit-optimize-contrast;
            float: left;
            margin-top: 8px;
            margin-left: 4px;
          }
          span {
            float: left;
          }
        }
        .invitation:hover {
          background-color: #f6f6f9;
        }
        .member-rank:hover .forever {
          display: none;
        }
        .member-rank:hover .up {
          display: block;
        }
      }
    }
    .help {
      position: absolute;
      right: 190px;
      display: inline-block;
      height: 100%;
      float: right;
      line-height: 132px;
    }

    .top_journal {
      position: absolute;
      right: 155px;
      display: inline-block;
      height: 100%;
      float: right;
      line-height: 132px;
    }
    .top_close {
      position: absolute;
      right: 25px;
      display: inline-block;
      height: 100%;
      float: right;
      line-height: 120px;
    }

    .top_all {
      position: absolute;
      right: 120px;
      display: inline-block;
      height: 100%;
      float: right;
      line-height: 132px;
    }

    .top_news {
      position: absolute;
      right: 80px;
      display: inline-block;
      height: 100%;
      float: right;
      line-height: 120px;
      top: -3px;

      > div {
        > sup {
          background-color: #ff8585;
          border-radius: 10px;
          color: #ffffff;
          display: inline-block;
          font-size: 8px;
          height: 18px;
          line-height: 16px;
          padding: 0 0px;
          text-align: center;
          white-space: nowrap;
          border: 1px solid #ffffff;
          top: 18px;
          right: 15px;
        }
      }
    }
  }

  .count {
    width: 100%;
    height: 50px;
    padding: 20px 20px;
    position: relative;
    background-color: #fff;

    > .breadcrumb {
      height: 50px;
      position: absolute;
      top: 0;
      left: 20px;
      width: calc(100% - 60px);
      white-space: nowrap;
      line-height: 40px;

      .el-breadcrumb {
        line-height: 50px;
        float: left;
        display: inline-block;

        .el-breadcrumb__inner {
          letter-spacing: 1px;
          color: @fontColor;

          > span {
            font-size: 16px;
          }
        }

        .path_item {
          font-weight: bold;
          cursor: pointer;
          color: @fontColor;
        }

        .path_item:hover {
          color: @green;
        }

        .el-breadcrumb__separator {
          color: @fontColor;
          opacity: 0.5;
          font-weight: bold;
        }
      }

      > .btn_url {
        float: right;
        display: inline-block;
        height: 100%;
        line-height: 50px;

        > div {
          height: 100%;

          > div {
            float: left;
            height: 100%;

            > div {
              .com_middle;
            }
          }
        }
      }
    }

    > .count_view {
      width: 100%;
      height: 100%;

      > div {
        width: 100%;
        height: 100%;
        background-color: @h_path_backColor;
        padding: 10px;
        border-radius: 10px;
      }
    }
  }
  .count_view {
    width: 100%;
    height: calc(100% - 150px);
  }

  .screenCount {
    .el-breadcrumb {
      .el-breadcrumb__inner {
        color: #000 !important;
      }

      .el-breadcrumb__separator {
        color: #000 !important;
      }

      .path_item:hover {
        color: red !important;
      }

      .path_item {
        color: #000 !important;
      }
    }

    > .count_view {
      > div {
        background-color: #122143;
      }
    }
  }

  .drawer_news {
    > div {
      > div {
        > section {
          background: #eee;
          height: 100%;

          .title {
            line-height: 50px;
            font-size: 20px;
            padding-left: 20px;
            font-weight: bold;
          }

          > div {
            > div {
              > div {
                padding: 20px;
                height: 100%;
                width: 100%;

                > div {
                  background: #fff;
                  border-radius: 5px;
                  width: 100%;
                  height: calc(100% / 5);
                  box-shadow: 0 0 5px #999;
                  padding: 0 10px;
                  position: relative;
                  color: #aaa;
                  margin-bottom: 20px;

                  .headline {
                    font-size: 20px;
                    font-weight: 600;
                    line-height: 37px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  .subtitle {
                    text-indent: 2rem;
                    height: 95px;
                    overflow: hidden;
                    line-height: 23px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                  }

                  .createTime {
                    position: absolute;
                    right: 10px;
                    bottom: 10px;
                  }

                  .delete {
                    position: absolute;
                    left: 10px;
                    bottom: 10px;
                  }
                }

                .unreadRead {
                  color: #232323;
                }
              }
            }
          }

          .el-scrollbar {
            width: 100%;
            height: calc(100% - 50px);

            .el-scrollbar__wrap {
              overflow-x: hidden;
            }

            .el-scrollbar__view {
              > div {
                position: relative;
                transform-origin: 0 0;
              }
            }
          }
        }
      }
    }
  }

  .preview {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 0;
    top: 0;
    overflow-y: auto;
    overflow-x: hidden;

    .preview_svg {
      position: absolute;
      right: 40px;
      top: 20px;
      z-index: 99999;
    }

    .preview_btn {
      position: absolute;
      right: 30px;
      bottom: 30px;
      z-index: 99999;
    }
  }
}
// .el-input{
//     width: 100% !important;
// }
.journal_dialog {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  .left {
    width: 58%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .right {
    width: 42%;
    height: 100%;
    background: #fff;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 30px;
    .search {
      width: 100%;
      .el-input {
        width: 200px;
        margin-right: 10px;
      }
      .el-button {
        margin-left: 20px;
      }
      .el-date-picker__time-header {
        display: none;
      }
    }
    .journal_table {
      width: 100%;
      height: 95%;
      overflow: hidden;
      margin-top: 30px;
      .el-table {
        height: 100%;
        th {
          background: #eee;
          border-bottom: 1px solid #999;
          border: none;
        }
      }
    }
  }
}
.el-date-picker__header {
  display: block !important;
}
.el-dialog .el-dialog__header {
  padding: 18px 20px;
}
.Invite {
  overflow: hidden;
  .info {
    padding: 30px;
    overflow: hidden;

    .title {
      text-align: center;
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .person {
      font-size: 16px;
      text-align: left;
      margin-bottom: 20px;
    }
    .num {
      font-size: 16px;
      text-align: left;
      margin-bottom: 20px;
    }
    .link {
      font-size: 16px;
      text-align: left;
      margin-bottom: 20px;
      a {
        text-decoration: underline;
        color: #0d7bf7;
      }
    }
    .button {
      width: 100%;
      margin-top: 30px;
      .el-button {
        margin: 0 20px;
      }
    }
  }
}
.help1 {
  // max-height: 600px;
  // padding: 30px;
  font-size: 14px;
  img {
    width: 550px;
  }
}
.help1::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
/*定义滚动条轨道 内阴影+圆角*/
.help1::-webkit-scrollbar-track {
  border-radius: 10px;
}

/*定义滑块 内阴影+圆角*/
.help1::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d2d2d2;
}
</style>
